export default "__VITE_ASSET__DmMAflSK__"